import {useGlobalWindowToken, useProjectAuthApiToken} from '@/di/di.root-container.hooks';
import {ErrorAction} from '@/services/ErrorsService/ErrorsService.constants';

import {useEffect} from 'react';

export const useLogoutOnBeforeUnload = (action?: ErrorAction): void => {
  const globalWindow = useGlobalWindowToken();
  const projectAuthApi = useProjectAuthApiToken();

  // Хук подписки на событие beforeunload для вызова метода разлогина.
  // Будет работать, только если action === ErrorAction.Logout,
  // в противном случае нам не нужно подписываться на событие и разлогинивать пользователя.
  useEffect(() => {
    if (action !== ErrorAction.Logout) return;

    const logout = (): Promise<void> => projectAuthApi.logout();
    // При перезагрузке страницы, закрытии браузера или при использовании кнопок
    // навигации браузера возвращаемый callback хука useEffect не отработает
    // и не вызовет логаут пользователя. Однако отработает событие beforeunload,
    // которое произведет разлогин пользователя
    // @See: https://jira.tcsbank.ru/browse/SP-8244
    globalWindow.addEventListener('beforeunload', logout);
    return () => {
      void logout();
      globalWindow.removeEventListener('beforeunload', logout);
    };
  }, []);
};
